import { ExperimentId } from 'core/type/ExperimentId';
import { getBootstrapConfig } from 'core/window/windowService';
import * as availability from 'component/page/detail/store/availability';
import * as availabilityDEPRECATED from 'component/page/detail/store/availabilityDEPRECATED';

type AvailabilityModuleType = typeof availability;
const config = getBootstrapConfig();
const isNewImplementationEnabled = config.experiments[ExperimentId.ACT_4944];

export type AvailabilityState = typeof isNewImplementationEnabled extends true ? availability.AvailabilityState : availabilityDEPRECATED.AvailabilityState;

const availabilityModule: AvailabilityModuleType = (() => {
    if (!isNewImplementationEnabled) {
        return availabilityDEPRECATED as unknown as AvailabilityModuleType;
    }
    return availability;
})();

export const {
    availabilityLoadFinished,
    resetAvailabilityState,
    setPassengers,
    setSelectedDate,
    setSelectedDateStateFromQueryParams,
    setOffer,
    setBookingRequirement,
    resetSelectedOfferCard,
    setOfferOptionSelectedDate,
    setOfferOption,
    setOfferNotification,
    fetchAvailability,
    availabilityInitialState,
    filterPossibleOfferOptions,
} = availabilityModule;

export default availabilityModule.default;

// note: remove this file post experiment integration
